import { getLayout } from './domain/layout';

// Layout Constants (derived)
const L = getLayout();
export const SIDEBAR_WIDTH = 350;
export const SEAT_RADIUS = L.seatRadius;
export const SEAT_TEXT_OFFSET = L.seatTextOffset;
export const RECTANGLE_WIDTH = L.rectangleWidth;
export const RECTANGLE_HEIGHT_6 = L.rectangleHeight6;
export const RECTANGLE_HEIGHT_7 = L.rectangleHeight7;
export const ROUND_TABLE_RADIUS = L.roundTableRadius;
export const ROUND_SEAT_RING_RADIUS = L.roundSeatRingRadius;

// Helper function to get seat count by table type
export function getSeatCountForTable(tableNumber: number): number {
  const table = L.tables.find(t => t.tableNumber === tableNumber);
  if (!table) return 0;
  if (table.seatCount) return table.seatCount;
  
  switch (table.type) {
    case 'rectangle_6':
      return 6;
    case 'rectangle_7':
      return 7;
    case 'round':
      return 10; // legacy support
    default:
      return 0;
  }
}

export function getMaxTableNumber(): number {
  return Math.max(...L.tables.map(t => t.tableNumber));
}

export function getMaxSeatCount(): number {
  return Math.max(...L.tables.map(t => getSeatCountForTable(t.tableNumber)));
}

// Unplaced guest layout
export const UNPLACED_GUEST_HEIGHT = 24;
export const UNPLACED_GUEST_SPACING = 8;

// Visual feedback colors
export const DROP_ZONE_COLOR = '#BBDEFB'; // Light Blue: Indicates an available slot
export const DROP_ZONE_HOVER_COLOR = '#64B5F6'; // Darker Blue: Indicates mouse is over the drop zone
export const NAME_HOVER_BG_COLOR = '#E0E0E0';   // A more visible grey for hover
export const NAME_DRAG_BG_COLOR = 'white';       // White background for dragged name
export const NAME_DRAG_BORDER_COLOR = '#9E9E9E'; // Border for dragged name
export const DROP_ZONE_SCALE = 1.2;      // Scale up the seat to indicate it's a drop target
export const DROP_ZONE_HOVER_SCALE = 1.5;      // Scale up the seat to indicate it's a drop target

// Staging area colors
export const UNPLACED_GUEST_BG_COLOR = '#f1f5f9';
export const UNPLACED_GUEST_HOVER_COLOR = '#dbeafe';

// Seat colors
export const SEAT_OCCUPIED_COLOR = '#10b981';  // Green for occupied seats
export const SEAT_EMPTY_COLOR = '#e5e7eb';     // Gray for empty seats

// Zoom Control Configuration
export const SCALE_FACTOR = 1.03; // Was 1.1, now much less sensitive
export const MIN_SCALE = 0.3;     // User can't zoom out more than this
export const MAX_SCALE = 2.5;     // User can't zoom in more than this

// Stage dimensions (calculated based on window and sidebar)
export const getStageWidth = (): number => {
  const sidebar = document.querySelector('.sidebar');
  const sidebarCollapsed = sidebar ? sidebar.classList.contains('collapsed') : false;
  return window.innerWidth - (sidebarCollapsed ? 0 : SIDEBAR_WIDTH);
};

export const getStageHeight = (): number => 
  window.innerHeight;

// Text rendering constants
export const LINE_HEIGHT = 9;
export const FONT_SIZE = 9;

// Content bounds padding
export const CONTENT_PADDING = 80;

// Storage Configuration
export const STORAGE_CONFIG = {
  DB_NAME: 'seatmapper',
  VERSION: 1,
  STORES: {
    VERSIONS: 'versions',
    SETTINGS: 'settings'
  }
};

// Storage keys
export const STORAGE_KEYS = {
  LAST_USED_VERSION: 'lastUsedVersion',
  SIDEBAR_COLLAPSED: 'sidebarCollapsed'
};

// Auto-save configuration
export const AUTO_SAVE_DEBOUNCE_MS = 500;

// History Management Configuration
export const HISTORY_CONFIG = {
  MAX_ENTRIES: 50, // Maximum number of undo/redo entries per version
  DEBOUNCE_MS: 300 // Debounce time for rapid actions
}; 
